<template>
    <div>
        <h2 class="mb-3">
            Preis
            <font-awesome-icon
                v-b-popover.hover.right="$t('intern_inserieren.info_price')"
                icon="question-circle"
                class="mm-link"
                style="font-size: 11pt;"
            />
        </h2>
        <div class="form-group" v-if="info != 'col'">
            <div class="input-group">
                <input type="text" class="form-control" @keypress="onlyForCurrency" v-model="euro" placeholder="0,00" @blur="$v.euro.$touch()" :class="{ 'is-invalid': $v.euro.$error }">
                <!--<input type="number" class="form-control" v-model="cent" placeholder="Cent" @blur="$v.cent.$touch()" :class="{ 'is-invalid': $v.cent.$error }">-->
                <div class="input-group-append">
                    <span class="input-group-text">€</span>
                </div>
                <div class="invalid-feedback" v-if="!$v.euro.required">Bitte Euro eingeben</div>
                <!--<div class="invalid-feedback" v-if="!$v.euro.integer">Bitte gültige Nummer in Euro eingeben</div>-->
               <!-- <div class="invalid-feedback" v-if="!$v.cent.integer">Bitte gültige Nummer in Cent eingeben</div>-->
            </div>
        </div>
        <div class="form-group mt-3">
            <select class="form-control" v-model="info">
                <option value="fix">Festpreis </option>
                <option value="var">Verhandlungspreis</option>
                <option value="col">auf Anfrage</option>
            </select>
        </div>
        <div class="form-group mt-3" v-if="info != 'col'">
            <select class="form-control" v-model="base">
                <option value="Stunde">pro Stunde</option>
                <option value="Tag">pro Tag</option>
                <option value="Show">pro Show</option>
                <option value="zwei Tage">für 2 Tage</option>
                <option value="drei Tage">für 3 Tage</option>
                <option value="Woche">pro Woche</option>
                <option value="Monat">pro Monat</option>
                <option value="Wochenende">Wochenendpreis</option>
            </select>
        </div>
        <div v-if="isMobile" class="mt-3 text-center">
            <button class="btn btn-success w-100" v-if="create"  @click="weiter()">Weiter</button>
            <button class="btn btn-success mb-1 w-100" v-if="!create"  @click="save(true)">Speichern und Schließen</button>
            <button class="btn btn-success w-100" v-if="!create"  @click="save()">Weiter</button>
        </div>
        <div v-else class="mt-3 text-right">
            <button class="btn btn-success" v-if="create"  @click="weiter()">Weiter</button>
            <button class="btn btn-success mx-2" v-if="!create"  @click="save(true)">Speichern und Schließen</button>
            <button class="btn btn-success" v-if="!create"  @click="save()">Weiter</button>
        </div>
    </div>
</template>

<script>
    import Inserat from '../../../classes/Inserat';
    import { integer, requiredIf } from 'vuelidate/lib/validators';
    import { IsMobileMixin } from '../../../mixins/IsMobile';

    export default {
        data() {
            return {
                euro: null,
                previousEuro : null,
                base: 'Woche',
                info: 'fix',
            }
        },
        watch: {
            info(val) {
                if(val == 'col'){
                    this.euro = null;
                   /* this.cent = null;*/
                }else {
                    if(this.base == ''){
                        this.base = 'Woche';
                    }
                }
            }
        },
        mixins: [IsMobileMixin],
        props:['create'],
        created() {
            this.scrollTop();
            if(this.create){
                let jsonObject = JSON.parse(localStorage.getItem('currentObject'));
                let inserat = Inserat.getObjectFromJSON(jsonObject);

                if(inserat.getPriceAmount()){
                    /*let price = inserat.getPriceAmount().split('.');*/
                    this.euro = inserat.getPriceAmount().replace(/,/g, '.');
                    /*this.cent = price[1];*/
                }

                if(inserat.getPriceInfo()){
                    this.info = inserat.getPriceInfo();
                }

                if(inserat.getPriceBase()){
                    this.base = inserat.getPriceBase();
                }
            }else {
                let object = this.$store.state.editObject;
                /*let price = object.price_amount.split('.');*/
                this.info = object.price_info;
                this.base = object.price_base;
                this.euro = object.price_amount.replace(/,/g, '.');
                /*this.cent = price[1];*/
            }
        },
        methods: {
            scrollTop() {
                window.scrollTo(0, 0);
            },
            onlyForCurrency ($event) {
               // console.log($event.keyCode); //keyCodes value
               let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

               // only allow number and one dot
               if ((keyCode < 48 || keyCode > 57) && (keyCode !== 44 || this.euro.indexOf(',') != -1)) { // 46 is dot
                  $event.preventDefault();
               }

               // restrict to 2 decimal places
               if(this.euro!=null && this.euro.indexOf(",") > -1 && (this.euro.split(',')[1].length > 1)){
                  $event.preventDefault();
               }
            },
            weiter(gotoNextTab = true) {
                this.$v.$touch();
                if(!this.$v.$invalid){
                    let inserat = Inserat.getObjectFromJSON(JSON.parse(localStorage.getItem('currentObject')));

                    this.euro ? inserat.setPriceAmount(this.euro.replace(/,/g, '.')) : inserat.setPriceAmount(this.euro)
                    inserat.setPriceBase(this.base);
                    inserat.setPriceInfo(this.info);

                    localStorage.setItem('currentObject', JSON.stringify(inserat));
                    if(gotoNextTab){
                      localStorage.setItem('currentObjectTab', 'location');
                      this.$emit('nextTab','location');
                    }

                }
            },
            save(closeAfter = false) {
                this.$v.$touch();
                if(!this.$v.$invalid){
                    let object = this.$store.state.editObject;
                    object.price_amount = this.euro ? this.euro.replace(/,/g, '.') : this.euro;
                    object.price_info   = this.info;
                    object.price_base   = this.base;

                    this.$store.state.loading = true;

                    this.$http.put('/objectApi/updateObject?id='+object.id, object).then(response => {
                        this.$store.state.editObject = object;
                        this.$store.state.loading = false;
                        this.$emit('success', response.data);

                        if(closeAfter){
                            setTimeout(() => {
                                this.$router.push({name: 'inserat-uebersicht', params: {page: this.$store.state.lastOpenedPage}});
                            }, 1000);
                        }
                        else{
                          this.$emit('nextTab','location');
                        }

                    }).catch(error => {
                        this.$store.state.loading = false;
                        this.$emit('error', error.response.data.data);
                    });
                }
            }
        },
        validations: {
            euro: {
                required: requiredIf(function () {
                    return this.info != 'col'
                })
            },
            /*cent: {integer},*/
        },
        beforeDestroy() {
          if(this.create){
            this.weiter(false);
          }
        }
    }
</script>

<style scoped>

</style>
